
namespace RioERP.Carts {

    @Serenity.Decorators.registerClass()
    export class CounterProductsDialog extends Serenity.EntityDialog<CounterProductsRow, any> {
        protected getFormKey() { return CounterProductsForm.formKey; }
        protected getIdProperty() { return CounterProductsRow.idProperty; }
        protected getLocalTextPrefix() { return CounterProductsRow.localTextPrefix; }
        protected getNameProperty() { return CounterProductsRow.nameProperty; }
        protected getService() { return CounterProductsService.baseUrl; }
        protected getDeletePermission() { return CounterProductsRow.deletePermission; }
        protected getInsertPermission() { return CounterProductsRow.insertPermission; }
        protected getUpdatePermission() { return CounterProductsRow.updatePermission; }

        protected form = new CounterProductsForm(this.idPrefix);

    }
}